import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// @ts-nocheck
var PREFIX = 'SHOPPING_CART_';
export var SHOPPING_CART_ACTIONS = {
  ADD_COURSE_TO_CART: /*#__PURE__*/"".concat(PREFIX, "ADD_COURSE_TO_CART"),
  REMOVE_COURSE_FROM_CART: /*#__PURE__*/"".concat(PREFIX, "REMOVE_COURSE_FROM_CART"),
  SET_LOADING_CART_MUTATION: /*#__PURE__*/"".concat(PREFIX, "SET_LOADING_CART_MUTATION"),
  SET_LOADING_CART: /*#__PURE__*/"".concat(PREFIX, "SET_LOADING_CART"),
  SET_LAST_ITEM_ADDED: /*#__PURE__*/"".concat(PREFIX, "SET_LAST_ITEM_ADDED"),
  SET_LAST_ITEM_ADDED_TYPE: /*#__PURE__*/"".concat(PREFIX, "SET_LAST_ITEM_ADDED_TYPE"),
  SET_STATE: /*#__PURE__*/"".concat(PREFIX, "SET_STATE"),
  SET_SHOW_SHOPPING_CART_POPUP: /*#__PURE__*/"".concat(PREFIX, "SET_SHOW_SHOPPING_CART_POPUP"),
  SET_FETCH_SHOPPING_CART_POPUP_CHUNK: /*#__PURE__*/"".concat(PREFIX, "SET_FETCH_SHOPPING_CART_POPUP_CHUNK"),
  SET_FLAG_CLASSIC_SHOPPING_CART: /*#__PURE__*/"".concat(PREFIX, "SET_FLAG_CLASSIC_SHOPPING_CART")
};
export var shoppingCartReducer = function shoppingCartReducer(state, action) {
  switch (action.type) {
    case SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingCartMutation: action.status
      });
    case SHOPPING_CART_ACTIONS.SET_LOADING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingCart: action.status
      });
    case SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED:
      return _objectSpread(_objectSpread({}, state), {}, {
        lastItemAdded: action.item
      });
    case SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        lastItemAddedType: action.itemType
      });
    case SHOPPING_CART_ACTIONS.SET_STATE:
      return _objectSpread(_objectSpread({}, state), action.state);
    case SHOPPING_CART_ACTIONS.SET_SHOW_SHOPPING_CART_POPUP:
      return _objectSpread(_objectSpread({}, state), {}, {
        showShoppingCartPopup: action.visibility
      });
    case SHOPPING_CART_ACTIONS.SET_FETCH_SHOPPING_CART_POPUP_CHUNK:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchShoppingCartPopupChunk: action.visibility
      });
    case SHOPPING_CART_ACTIONS.SET_FLAG_CLASSIC_SHOPPING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        flagClassicShoppingCart: action.status
      });
    default:
      return state;
  }
};